import { Placement } from '@floating-ui/react';
import { ReactNode } from 'react';

/** What the explanation is: its trigger's icon and its accent. */
export enum JxtInfoTooltipTypeEnum {
  /** What a section or a value is (ⓘ). */
  Info = 'info',
  /** How something works, an answer to a question (?). */
  Help = 'help',
  /** A tip to get more out of it (💡). */
  Tip = 'tip',
}

export interface IJxtInfoTooltip {
  type?: JxtInfoTooltipTypeEnum;
  /** In bold on top, e.g. "Pas besoin de réserver". */
  title?: string;
  description: ReactNode;
  /** Under the description, a link-like action, e.g. "En savoir plus". */
  action?: { label: string; onClick: () => void };
  /** The trigger's name for screen readers: the title by default. */
  triggerLabel?: string;
  /** Where it opens from its trigger: under it by default, flipped when there is no room. */
  placement?: Placement;
}
